import { render, staticRenderFns } from "./groupTableDataView.vue?vue&type=template&id=7637c1aa&scoped=true"
import script from "./groupTableDataView.vue?vue&type=script&lang=js"
export * from "./groupTableDataView.vue?vue&type=script&lang=js"
import style0 from "./groupTableDataView.vue?vue&type=style&index=0&id=7637c1aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637c1aa",
  null
  
)

export default component.exports